<template>
    <div class="supportPage wrapper">
        <div class="titleWrap mainPageTitle">
            <h2 v-if="$mq=='lg'">{{'pages/support.title' | trans }}</h2>
            <ButtonWithLoading
                v-if="!sessionId"
                classes="btn btnThin btnSmallSec startChat"
                :loading="sessionLoading"
                :title="'pages/support.button.new-conversation' | trans"
                @click="startChat"
            />
        </div>
        <div class="mainContent">

            <div v-if="!sessionId && !getChatHistory" class="nullState wrap">
                <div class="cont">
                    <img src="/assets/img/no-messages.svg" alt="msg">
                    <span class="title">{{'pages/support.no-messages' | trans }}</span>
                    <span class="subt">{{'pages/support.create-new-conversation' | trans }}</span>
                    <ButtonWithLoading
                        classes="btn btnThin btnSmallSec startChat"
                        :loading="sessionLoading"
                        :title="'pages/support.button.new-conversation' | trans"
                        @click="startChat"
                    />
                </div>
            </div>

            <ChatHistory
                v-if="!sessionId && getChatHistory"
                v-on:getChatHistoryIndex="chatHistoryIndex = $event"
            />

            <Chat
                v-if="sessionId || chatHistoryIndex"
                :loadChatHistory="chatHistoryIndex"
                :sessionId="sessionId"
                v-on:quitChat="sessionId = null"
            />

        </div>
    </div>
</template>


<script>
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
    import ButtonWithLoading from '../components/form/ButtonWithLoading';
    import Chat from '../components/Support/Chat';
    import ChatHistory from '../components/Support/ChatHistory';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        data() {
          return {
              chatHistoryIndex: null,
              sessionId: null,
              sessionLoading: false,
          }
        },

        components : { ButtonWithLoading, PulseLoader, Chat, ChatHistory },

        methods: {
            ...mapActions(['initChatHistory']),
            startChat: function () {
                this.sessionLoading = true;
                axios.get('/api/support/start-session').then( res => {
                    this.sessionLoading = false;
                    this.sessionId = res.data.session_id;
                }).catch(error =>{
                    console.log(error);
                });
            },
        },
        computed: {
            ...mapGetters(["getChatHistory"])
        },
        created() {
            this.initChatHistory();
        }
    }
</script>
